import styled, { keyframes, css } from 'styled-components';
import { SIZE } from 'common/sizes';
import { DEFAULT_FONT_FAMILY } from 'common/constants';
import { BUTTON_PRIMARY } from 'components/TCButton/styles';

const appear = keyframes`
    from {transform: translateY(${SIZE.TWENTYFOUR}px); opacity: 0;}
    to { transform: translateY(0); opacity: 1;}
`

const appearAnimation = props =>
    css`
    ${appear} 0.350s ease-out;
`

const disappear = keyframes`
    from { transform: translateY(0); opacity: 1;}
    to {transform: translateY(${SIZE.TWENTYFOUR}px); opacity: 0;}
    
`

const disappearAnimation = props =>
    css`
    ${disappear} 0.350s ease-out;
`

export interface ContainerProps {
    shouldShow: boolean;
}

export const Container = styled.div`
    display:flex;
    flex-flow: column;
    background: #FFF;
    width: 462px;
    border: 1px solid #A0A0A0;
    padding: 26px 100px 57px  100px;
    animation: ${(props: ContainerProps) => props.shouldShow ? appearAnimation : disappearAnimation};
    animation-fill-mode: forwards;
    border-radius: 3px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.12);
    filter:none;
`;

export const Title = styled.span`
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 24px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #000000;
    margin-top: 20px;
`;

export const DescriptionContainer = styled.div`
    margin-top: 15px;
    margin-bottom: 35px;
    text-align: center;
`;

export const BottomTextContainer = styled.div`
    margin-top: 25px;
    margin-bottom: 25px;
    padding: 0px;
`;

export const ButtonContainer = styled.div`
    padding: 0px 80px;
    height: 44px;    
    ${BUTTON_PRIMARY}{
        width: 100%;    
        height: 44px;    
    }
`;

export const BodyTextCenter = styled.div`
    font-family: Rubik;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.43;
    letter-spacing: normal;
    text-align: center;
    color: #000000;
`;

export const BodyTextLeft = styled.span`
    font-family: Rubik;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.43;
    letter-spacing: normal;
    text-align: left;
    color: #000000;
`;

export const LineSpacer = styled.div`
    width: 100%;
    height: ${(props: ContainerProps) => props.shouldShow ? appearAnimation : disappearAnimation};
`;

export const Close = styled.div`
    position: absolute;
    right: ${SIZE.HALF}px;
    top: ${SIZE.HALF}px;
    &:hover {
        cursor: pointer;
    };
`